import { useEffect, useState } from 'react';
import { createHttpService } from '../apis/ApiService';

export type TPublicBranding = {
  logoUrl: string | null;
  primaryColor: string | null;
  secondaryColor: string | null;
  accentColor: string | null;
  instituteName: string | null;
};

/**
 * Detects the institute slug from the subdomain and fetches public branding.
 * Used on the login page before authentication.  Returns null while loading.
 * Returns an empty branding object if no matching institute is found.
 */
export const usePublicBrandingHook = (): TPublicBranding | null => {
  const [branding, setBranding] = useState<TPublicBranding | null>(null);

  useEffect(() => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');

    if (parts.length < 3) {
      setBranding({ logoUrl: null, primaryColor: null, secondaryColor: null, accentColor: null, instituteName: null });
      return;
    }

    const slug = parts[0];
    if (!slug || slug === 'www' || slug === 'admin') {
      setBranding({ logoUrl: null, primaryColor: null, secondaryColor: null, accentColor: null, instituteName: null });
      return;
    }

    const httpAPI = createHttpService();
    httpAPI.branding
      .get<TPublicBranding>(`/public/by-slug/${encodeURIComponent(slug)}`)
      .then((data) => setBranding(data))
      .catch(() => setBranding({ logoUrl: null, primaryColor: null, secondaryColor: null, accentColor: null, instituteName: null }));
  }, []);

  return branding;
};
